import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "top-stylist-performance-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "basic-table table-responsive" }
const _hoisted_5 = { class: "table mb-0" }
const _hoisted_6 = { class: "employee-info d-flex align-items-center" }
const _hoisted_7 = { class: "img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-block fw-semibold" }
const _hoisted_10 = { class: "d-block text-body" }
const _hoisted_11 = { class: "ratings lh-1" }
const _hoisted_12 = { class: "d-inline-block lh-1 text-xs text-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Top Stylist Performance")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stylists.slice(0, 5), (stylist) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: stylist.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: stylist.image,
                          alt: "user-image"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(stylist.name), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(stylist.totalBookings) + " Total Bookings ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                        return _createElementVNode("i", {
                          key: star,
                          class: _normalizeClass(_ctx.getStarClass(stylist.rating, star))
                        }, null, 2)
                      }), 64)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(stylist.rating), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}